import {useEffect, useState} from "react";
import cls from "classnames";
import useModalPortalState from "store/modalPortalState";
import usePreferencesStore from "store/preferencesStore";

export default function ModalPortal() {
  const modalPortalState = useModalPortalState(state => state);
  const [isDrishy, setIsDrishy] = useState(false);
  const [contentClass, setContentClass] = useState("");

  useEffect(() => {
    if(modalPortalState.isOpened) {
      addContentClass();
      setTimeout(() => {
        setIsDrishy(true);
      });
    } else {
      removeContentClass();
    }
  }, [modalPortalState.isOpened]);

  function addContentClass() {
    const initialContentClass = modalPortalState.options?.isStandardSize ? "modalportal-content-standard" : "";
    setContentClass(initialContentClass);
  }

  function removeContentClass() {
    setIsDrishy(false);
    setTimeout(() => {
      setContentClass("");
    }, 240); // safe remove class
  }

  return (
    <div
      className={cls(
        'modalportal-container',
        isDrishy && 'drishy'
      )}
    >
      <div className="backdrop"></div>

      <div className="modalportal mfix">
        <ModalPortalContent
          className={contentClass}
          options={modalPortalState.options}
        >
          {modalPortalState.content}
        </ModalPortalContent>
      </div>
    </div>
  )
}

export function ModalPortalContent({children, className}) {
  const preferences = usePreferencesStore(state => state.preferences?.data);

  return (
    <div className={cls(
      className,
      "modalportal-content",
      preferences?.isStandalone && "modalportal-content-border"
    )}>
      {children}
    </div>
  )
}